<template>
  <header id="header">
    <div class="row">
      <div class="container">
        <div class="row align-items-center">
          <router-link :to="{name:'home'}" class="logo col-7 col-sm-7 col-md-3 col-lg-3 mr-auto">
            <img :src="require('../assets/img/colour-logo.png')" alt="Cherrytree Logo">
          </router-link>
          <div class="col-5 col-sm-4 d-lg-none align-self-start">
            <div
              class="menuButton btn btn-outline btn-primary btn-sm d-block"
              @click="menuToggle"
            >Menu <MenuIcon/></div>
          </div>

          <MemberActions v-if="this.$store.state.auth.loggedIn === true" class="col-12 col-md-12 col-lg-5" />
          <PublicActions v-else-if="this.$store.state.auth.loggedIn === false" class="col-12 col-md-12 col-lg-5"/>

          <SearchBar class="col-12 col-lg-4"/>

          <div class="col-5 text-right">
            <RenewButton class="col-5 float-left mdRenewBtn"/>
            <!--<div
              @click="categoriesToggle"
              class="btn btn-primary btn-sm categories-btn d-lg-none triangle whiteTriangle buttonAlignTriangle"
              :class="(showCategories) ? 'activeTriangle' : ''"
              id="shopButton"
            >Shop</div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <MainMenu :show="showMenu" :menuToggle="menuToggle"/>
      </div>
    </div>
    <!--<div class="row">
      <ShopMenu :showDesktop="showShopMenu" :expanded="showCategories"/> 
    </div> -->
    <div class="container renewDiv">
      <RenewButton class="col-12 mx-auto" />
    </div>
  </header>
</template>

<script>
import MainMenu from "./TheMainMenu";
import SearchBar from "./TheAlgoliaSearchBar";
// import ShopMenu from "./TheShopMenu";
import MemberActions from "./TheMemberActions";
import PublicActions from "./ThePublicActions";
import RenewButton from "@/components/RenewButton";

import MenuIcon from "@/assets/img/menu.svg";

export default {
  name: "ThePageHeader",
  components: {
    MainMenu,
    SearchBar,
    // ShopMenu,
    MemberActions,
    PublicActions,
    MenuIcon,
    RenewButton
  },
  data() {
    return {
      showMenu: false,
      showCategories: false
    };
  },
  methods: {
    menuToggle() {
      this.showMenu = !this.showMenu;
      document.getElementsByTagName("body")[0].classList = (this.showMenu) ? "noscroll" : ""
    },
    categoriesToggle() {
      this.showCategories = !this.showCategories;
    }
  },
  watch: {
    $route() {
      this.showMenu = false;
      this.showCategories = false;
    }
  },
  computed:{
    showShopMenu(){
      if(this.$store.state.auth.loggedIn) return true;
      if(this.$route.fullPath.includes('/shop/')) return true;
      if(this.$route.path == "/shop") return true;

      return false
    }
  }
};
</script>

<style lang="scss" scoped>
// $CTRed: #AF272F;
#header {
	margin-bottom: 10px;
}

.logo {
  img {
    max-width: 100%;
    height: auto;
    padding: 2px 4%;
  }
}

.menuButton{
  // color: $CTRed;
  // background-color: white;
  margin-top: 8px;
  // border: white;
  svg{
    // fill:$CTRed;
    fill: white;
    height:19px;
    // margin-bottom:2px;
    vertical-align: top;
  }
}

.categories-btn{
  margin-left:auto;
  font-size:0.9em;
}

#header{
  margin-top:10px;
}

// #shopButton:after {
//   border-color: #fff;
//   top: 0px;
//   right: -7px;
//   height: 10px;
//   width: 10px;
//   margin-right: 6px;
// }


.renewDiv {
  display: none;
  // box-sizing: border-box;
  // padding: 0 1rem;
  margin-bottom: 10px;
}

.mdRenewBtn {
  display: none;
}

@include media-breakpoint-down(lg) {
  
}

@include media-breakpoint-down(md) {
  .mdRenewBtn {
    display: block;
  }
}

@include media-breakpoint-down(sm) {
  .renewDiv {
    display: block;
  }
  .mdRenewBtn {
    display: none !important;
  }
}



</style>
